import { render, staticRenderFns } from "./historical-invoice-reports.vue?vue&type=template&id=566a360f&"
import script from "./historical-invoice-reports.vue?vue&type=script&lang=js&"
export * from "./historical-invoice-reports.vue?vue&type=script&lang=js&"
import style0 from "./historical-invoice-reports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports